export default "__VITE_ASSET__Ch8jJ40W__"